import React from 'react';

import styles from './FlatTreeNodeError.module.scss';

interface IFlatTreeNodeErrorProps {
	errorText?: string;
	style?: React.CSSProperties;
}

const FlatTreeNodeError = ({
	errorText,
	style,
}: IFlatTreeNodeErrorProps) => {
	return errorText ? (
		<span
			className={styles.error}
			style={style}
		>
			{errorText}
		</span>
	) : null;
};

export default FlatTreeNodeError;
